import { TICKET_TYPE } from '../../constants/userConstants';
var isAffiliate = function (ticketType) {
    switch (ticketType) {
        case TICKET_TYPE.NAVER:
        case TICKET_TYPE.LG_BUNDLE:
        case TICKET_TYPE.LG_SERVICE:
        case TICKET_TYPE.KT_BUNDLE:
        case TICKET_TYPE.KT_SERVICE:
            return true;
        default:
            return false;
    }
};
export default isAffiliate;
